import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, SvgIcon, Tooltip, CircularProgress, IconButton } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'recompose';

function PropertyDetailsTitle({ explorePropertyDetailsIsOpen, title, zillowUrl, isLoadingPopupData, onCompsPdoClick, badgeContent, isMobile }) {
  return (
    <>
      <Typography variant='h6' style={{ marginRight: isMobile ? 30 : 8 }}>{title}</Typography>
      <div style={{ marginRight: 8 }}>
        <Tooltip title='View on Zillow' placement='top'>
          <IconButton onClick={() => window.open(zillowUrl)}>
            <SvgIcon>
              <path d='M17.381 18.056c-7.43.445-15.51 3.135-16.362 3.51l.989-2.789c2.521-1.166 8.775-3.469 16.486-4.019c-.15.57-.961 2.671-1.125 3.285l.012.013zm2.649-7.509s-.363.765-.709 1.814c-2.954.18-7.635 1.154-9.915 1.98c1.186-1.08 8.686-8.61 8.686-8.61C20.985 7.71 24 10.155 24 10.155l-3.97.395v-.003zm-17.55.33c1.647-.75 6.265-2.146 10.685-3.181c0 0-8.497 7.845-10.859 10.275l1.95-5.28c-1.516.225-2.184.315-4.256.75l2.479-2.551l.001-.013zm10.6-8.432c.734.359 3.45 2.205 4.419 2.888c-3.096.074-9.135 1.409-11.652 2.25c2.065-1.568 5.903-4.53 7.233-5.148v.01z' />
            </SvgIcon>
          </IconButton>
        </Tooltip>
        {explorePropertyDetailsIsOpen &&
          <Tooltip title='View comps as a Property Data object'>
            <IconButton onClick={onCompsPdoClick}>
              <SvgIcon>
                <path d='M19.31 18.9C19.75 18.21 20 17.38 20 16.5C20 14 18 12 15.5 12S11 14 11 16.5 13 21 15.5 21C16.37 21 17.19 20.75 17.88 20.32L21 23.39L22.39 22L19.31 18.9M15.5 19C14.12 19 13 17.88 13 16.5S14.12 14 15.5 14 18 15.12 18 16.5 16.88 19 15.5 19M5 20V12H2L12 3L22 12H20.18C19 10.77 17.34 10 15.5 10C11.92 10 9 12.92 9 16.5C9 17.79 9.38 19 10.03 20H5Z' />
              </SvgIcon>
            </IconButton>
          </Tooltip>
        }
      </div>
      {isLoadingPopupData && <CircularProgress key={0} size={24} color='secondary'/>}
      <div style={{ flexGrow: 1 }}></div>
      {badgeContent}
    </>
  )
}

const styles = theme => ({

});

function mapState(state) {
  const { appState } = state;
  return {
    isMobile: appState.isMobile,
  };
}

export default compose(withStyles(styles), connect(mapState))(PropertyDetailsTitle);
